<template>
    <div v-loading="loading" :class="tosFromLogin ? 'tos-from-login' : ''">
        <div v-html="convertMarkdownToHtml(tos)"></div>
        <div v-if="!isEnrollmentTOS && tosFromLogin">
            <div class="u-mt4 u-mb4">
                <el-checkbox data-cy="accept-checkbox" v-model="checked">
                    {{ t('enrollment.i_have_read_and_accept_tos') }}
                </el-checkbox>
            </div>
            <el-button data-cy="accept-button" type="primary" class="el-button--wide" @click="advance" :disabled="!checked">
                {{ t('enrollment.agree_to_terms') }}
            </el-button>
        </div>
    </div>
</template>

<script>
  import marked from 'marked'
  import {mapState, mapActions, mapMutations} from 'vuex'
  import {isTosChanged, TOS_CHANGED_CAUSE} from '@shared_src/utils/api.utils'
  
  export default {
    name: 'terms-of-service',
    props: {
      isEnrollmentTOS: {
        type: Boolean
      }
    },
    methods: {
      ...mapActions('enrollment', ['approveTos']),
      ...mapMutations('enrollment', ['confirmTos']),
      convertMarkdownToHtml: (content) => {
        if (!content) return ''
        let converted = marked(content)

        return converted
      },
      advance () {
        if (this.isEnrollmentTOS) {
          this.confirmTos(true)
          this.$emit('handleEnrollmentDialogTOS', true)
        } else {
          this.loading = true
          // the gateway records the ToS acknowledgement itself in approve-tos (BC-21141)
          this.approveTos().then((result) => {
            this.loading = false
            if (isTosChanged(result)) {
              // not approved: the store now holds the new text, which has to be read and accepted again
              this.checked = false
              this.$elAlert(this.t(TOS_CHANGED_CAUSE), this.t('global.notice'))
              return
            }
            this.$router.replace('/dashboard')
          }, () => {
            delete localStorage.token
            localStorage.removeItem('last_location')
            this.loading = false
            this.$router.replace('/login')
          })
        }
      }
    },
    data () {
      return {
        checked: false,
        loading: false
      }
    },
    computed: {
      ...mapState('enrollment', ['tos']),
      tosFromLogin () {
        return this.$route.params.backLink === '0'
      }
    }
  }
</script>
<style lang="scss">

.tos-from-login {
    width: 50vw;
    max-width: 600px;
    margin: 10vh auto 0;
    .el-checkbox__label {
        white-space: normal;
    }
}
</style>
